import { useNavigate, useParams } from 'react-router-dom'
import { useAddNewLessonMutation, useGetSingleLessonQuery } from './lessonsApiSlice'
import PulseLoader from 'react-spinners/PulseLoader'
import useTitle from '../../hooks/useTitle'
import Presence from "../presence/Presence"
import { faArrowAltCircleRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useState } from 'react'
import { useUpdateAllPresenceByAdminMutation } from '../presence/presencesApiSlice'
const ShowLesson = () => {
    useTitle('geshtop-Exercise: Edit Lesson')
    const[reason,setReason]= useState("המתשמש נוכח אך לא עדכן")
    const[q,setQ]= useState("")
    const { lessonId, groupId , type} = useParams()
    const navigate = useNavigate()
    const {
        data: lesson,
        isLoading,
        isSuccess,
        isError,
        error
    } = useGetSingleLessonQuery(lessonId, {
        // pollingInterval: 60000,
        // refetchOnFocus: true,
        refetchOnMountOrArgChange: true
    })

    const [updateAllPresenceByAdmin, {
        isLoading: isLoadingByAdmin,
        isSuccess: isSuccessByAdmin,
        isError: isErrorByAdmin,
        error: errorByAdmin
    }] = useUpdateAllPresenceByAdminMutation()

    let content

    if (isLoading) content = <PulseLoader color={"#FFF"} />

    if (isError) {
        content = <p className="errmsg">{error?.data?.message}</p>
    }
    const updateAllClickEvent = ()=>{
        updateAllPresenceByAdmin({lessonId:lessonId, reason:reason})
    }
    if (isSuccess) {
        const filtered =  lesson.presences?.length? (q!==""?lesson.presences.filter(x=>(x.name.toLowerCase().indexOf(q.toLowerCase())>-1) || x.username.toLowerCase().indexOf(q.toLowerCase())> -1):lesson.presences) :[]
        const tableContent = filtered.map(presence => <Presence key={presence._id} reason={reason} presence={presence} />)

        content = (
            <>
            <div className='d-flex' style={{justifyContent:"space-between"}}>
                <div className='d-flex'>
                <button
                            className="icon-button"
                            title="Back"
                            onClick={()=>{navigate(`/${type}/${groupId}/lessons`)}}
                        >
                            <FontAwesomeIcon icon={faArrowAltCircleRight} />
                        </button>
                      
                        <input
                   className={`form__input`}
                    id="q"
                    name="q"
                    type="text"
                    autoComplete="off"
                    value={q}
                    placeholder="חיפוש לפי שם או תעודת זהות"

                    onChange={(e)=>setQ(e.target.value)}
                /> 
                </div>
          
               
                <div className='d-flex'>
                <label className='form__label'>
                            סיבת עדכון מנהל
                        </label>
                <input
                   className={`form__input`}
                    id="reason"
                    name="reason"
                    type="text"
                    autoComplete="off"
                    value={reason}
                    placeholder="סיבת העדכון על ידי המנהל"
                    onChange={(e)=>setReason(e.target.value)}
                />
                <button className='table__button bg-white rounded-2xl mr-2'
                title="Update All"
                 onClick={updateAllClickEvent}
                >
                   עדכון לכולם
                </button>
                </div>
                
               
            </div>


   
           
               

            <table className="table table--presences mt-4">
                <thead className="table__thead">
                <tr>
                        <th scope="col" className="table__th presence__presencename">שיעור</th>
                        <th scope="col" className="table__th presence__lessons">מס' שיעורים</th>

                        <th scope="col" className="table__th presence__name">תאריך</th>
                        <th scope="col" className="table__th presence__name">תעודת זהות</th>
                        <th scope="col" className="table__th presence__name">שם</th>
                        <th scope="col" className="table__th presence__name">נוכחות</th>
                        <th scope="col" className="table__th presence__edit">#</th>
                    </tr>
                </thead>
                <tbody>
                    {tableContent}
                </tbody>
            </table>
            </>
        )
    }

    return content
}
export default ShowLesson